module.exports = __webpack_public_path__ + "45077e08d61c642bbe441bc444bf8d7b.png";